import { Edit, LightbulbOutlined, Close as CloseIcon } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React from "react";

export default ({
  open,
  onClose,
  onChoose,
}: {
  open: boolean;
  onClose: () => void;
  onChoose: (type: string) => void;
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Choose Sequence Type
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Button
          variant="outlined"
          startIcon={<Edit />}
          onClick={() => onChoose("")}
          sx={{ mb: 2 }}
          fullWidth
        >
          Start from scratch
        </Button>
        <Button
          variant="outlined"
          fullWidth
          startIcon={<LightbulbOutlined />}
          onClick={() => onChoose("ai")}
        >
          AI Generated Sequence
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
